import { z } from 'zod';
export const ServerJobStatusSchema = z.enum([
    'running',
    'queued',
    'scheduled',
    'failing',
    'permanently_failed',
    /** 서버 재시작으로 강제 중단된 job. last_error 에 사유 기록. graphile-worker 자체 status 가 아니라 worker_runs 에서 파생. */
    'interrupted_by_restart',
]);
export const ServerJobSchema = z.object({
    id: z.string(),
    taskIdentifier: z.string(),
    payload: z.record(z.string(), z.unknown()).nullable(),
    priority: z.number().int(),
    runAt: z.string(),
    attempts: z.number().int().nonnegative(),
    maxAttempts: z.number().int().positive(),
    lastError: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    key: z.string().nullable(),
    lockedAt: z.string().nullable(),
    lockedBy: z.string().nullable(),
    status: ServerJobStatusSchema,
    /** payload 에서 추출한 데이터소스 id (있을 때). UI 에서 이름 resolve 용. */
    dataSourceId: z.string().nullable(),
    /** worker_runs 의 최신 row 에서 가져온 진행률 (있을 때). */
    progressTotal: z.number().int().nonnegative().nullable(),
    progressDone: z.number().int().nonnegative().nullable(),
    /** 현재 처리 중인 항목 (예: "public.orders"). */
    progressItem: z.string().nullable(),
    /** worker_runs.startedAt — UI 에서 진행 시간 계산용. */
    runStartedAt: z.string().nullable(),
    /** true 면 이 job 이 서버 재시작으로 중단됨 (worker_runs.status = interrupted_by_restart). */
    interruptedByRestart: z.boolean(),
});
export const ServerJobListSchema = z.object({
    jobs: z.array(ServerJobSchema),
    /**
     * payload 의 dataSourceId 에 대응하는 데이터소스 이름 매핑.
     * id 가 있어도 데이터소스가 이미 삭제됐으면 누락.
     */
    dataSourceNames: z.record(z.string(), z.string()),
});
export const DataSourceJobsResponseSchema = z.object({
    jobs: z.array(ServerJobSchema),
});
export const CancelServerJobResponseSchema = z.object({
    ok: z.boolean(),
    job: ServerJobSchema.nullable(),
});
export const DeleteServerJobResponseSchema = z.object({
    deleted: z.boolean(),
    reason: z.string().optional(),
});
//# sourceMappingURL=server-jobs.js.map